import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { useTranslation } from '../../common/i18n/useTranslation';
import { WbGridCol, WbGridRow, WbIcon, WbTag, WbText } from '@workbench/react';
import LogoutButton from '../../common/components/input/LogoutButton';
import MailToButton from '../MailToButton';
import { OPERATING_FLUID_MAIL_ADDRESS } from '../../utils/links';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles()((theme: Theme) => ({
    spacing: {
        marginBottom: theme.spacing(3),
        whiteSpace: 'pre-line',
    },
}));

function RegistrationUnderReview() {
    const translate = useTranslation();
    const { classes } = useStyles();
    return (
        <>
            <WbGridRow className={classes.spacing}>
                <WbGridCol mq4={5}>
                    <WbText size="m">{translate('registration_success_landing_page_message')}</WbText>
                </WbGridCol>
                <WbGridCol mq4={4}>
                    <WbTag variant="warning">
                        <WbIcon name="bds/mb-star/24" />
                        {translate('confirmation_in_progress')}
                    </WbTag>
                </WbGridCol>
            </WbGridRow>
            <WbText size="m" className={classes.spacing}>
                <FormattedMessage
                    id="registration_success_landing_page_message_additional"
                    defaultMessage={'registration_success_landing_page_message_additional'}
                />
            </WbText>
            <WbText size="m" className={classes.spacing}>
                {translate('registration_success_landing_page_message_help')}
                <MailToButton mailto={OPERATING_FLUID_MAIL_ADDRESS} label={OPERATING_FLUID_MAIL_ADDRESS} />
            </WbText>
            <LogoutButton variant="secondary" size="s" theme="dark" />
        </>
    );
}

export default RegistrationUnderReview;
